export const countries = [
  {
    label: "افغانستان",
    value: "Afghanistan",
    code: "AF",
  },
  {
    label: "آلبانی",
    value: "Albania",
    code: "AL",
  },
  {
    label: "الجزایر",
    value: "Algeria",
    code: "AG",
  },
  {
    label: "ساموآی آمریکایی",
    value: "AmericanSamoa",
    code: "AS",
  },
  {
    label: "آندورا",
    value: "Andorra",
    code: "AN",
  },
  {
    label: "آنگولا",
    value: "Angola",
    code: "AO",
  },
  {
    label: "آنگویلا",
    value: "Anguilla",
    code: "AI",
  },
  {
    label: "قطب جنوب",
    value: "Antarctica",
    code: "AQ",
  },
  {
    label: "آنتیگوا و باربودا",
    value: "Antigua and Barbuda",
    code: "AC",
  },
  {
    label: "آرژانتین",
    value: "Argentina",
    code: "AR",
  },
  {
    label: "ارمنستان",
    value: "Armenia",
    code: "AM",
  },
  {
    label: "آروبا",
    value: "Aruba",
    code: "AW",
  },
  {
    label: "استرالیا",
    value: "Australia",
    code: "AS",
  },
  {
    label: "اتریش",
    value: "Austria",
    code: "AU",
  },
  {
    label: "آذربایجان",
    value: "Azerbaijan",
    code: "AJ",
  },
  {
    label: "باهاما",
    value: "Bahamas",
    code: "BF",
  },
  {
    label: "بحرین",
    value: "Bahrain",
    code: "BA",
  },
  {
    label: "بنگلادش",
    value: "Bangladesh",
    code: "BG",
  },
  {
    label: "باربادوس",
    value: "Barbados",
    code: "BB",
  },
  {
    label: "بلاروس",
    value: "Belarus",
    code: "BY",
  },
  {
    label: "بلژیک",
    value: "Belgium",
    code: "BE",
  },
  {
    label: "بلیز",
    value: "Belize",
    code: "BZ",
  },
  {
    label: "بنین",
    value: "Benin",
    code: "BJ",
  },
  {
    label: "برمودا",
    value: "Bermuda",
    code: "BM",
  },
  {
    label: "بوتان",
    value: "Bhutan",
    code: "BT",
  },
  {
    label: "بولیوی کشور چند ملیتی بولیوی",
    value: "Bolivia, Plurinational State of Bolivia",
    code: "BO",
  },
  {
    label: "بوسنی و هرزگوین",
    value: "Bosnia and Herzegovina",
    code: "BA",
  },
  {
    label: "بوتسوانا",
    value: "Botswana",
    code: "BW",
  },
  {
    label: "جزیره بووه",
    value: "Bouvet Island",
    code: "BV",
  },
  {
    label: "برزیل",
    value: "Brazil",
    code: "BR",
  },
  {
    label: "منطقه اقیانوس هند بریتانیا",
    value: "British Indian Ocean Territory",
    code: "IO",
  },
  {
    label: "برونئی دارالسلام",
    value: "Brunei Darussalam",
    code: "BN",
  },
  {
    label: "بلغارستان",
    value: "Bulgaria",
    code: "BG",
  },
  {
    label: "بورکینافاسو",
    value: "Burkina Faso",
    code: "BF",
  },
  {
    label: "بوروندی",
    value: "Burundi",
    code: "BI",
  },
  {
    label: "کامبوج",
    value: "Cambodia",
    code: "KH",
  },
  {
    label: "کامرون",
    value: "Cameroon",
    code: "CM",
  },
  {
    label: "کانادا",
    value: "Canada",
    code: "CA",
  },
  {
    label: "کیپ ورد",
    value: "Cape Verde",
    code: "CV",
  },
  {
    label: "جزایر کیمن",
    value: "Cayman Islands",
    code: "KY",
  },
  {
    label: "جمهوری آفریقای مرکزی",
    value: "Central African Republic",
    code: "CF",
  },
  {
    label: "چاد",
    value: "Chad",
    code: "TD",
  },
  {
    label: "شیلی",
    value: "Chile",
    code: "CL",
  },
  {
    label: "چین",
    value: "China",
    code: "CN",
  },
  {
    label: "جزیره کریسمس",
    value: "Christmas Island",
    code: "CX",
  },
  {
    label: "جزایر کوکوس (کیلینگ)",
    value: "Cocos (Keeling) Islands",
    code: "CC",
  },
  {
    label: "کلمبیا",
    value: "Colombia",
    code: "CO",
  },
  {
    label: "کومور",
    value: "Comoros",
    code: "KM",
  },
  {
    label: "کنگو",
    value: "Congo",
    code: "CG",
  },
  {
    label: "کنگو جمهوری دموکراتیک",
    value: "Congo, The Democratic Republic of the",
    code: "CD",
  },
  {
    label: "جزایر کوک",
    value: "Cook Islands",
    code: "CK",
  },
  {
    label: "کاستاریکا",
    value: "Costa Rica",
    code: "CR",
  },
  {
    label: "ساحل عاج",
    value: "Ivory Coast",
    code: "CI",
  },
  {
    label: "کرواسی",
    value: "Croatia",
    code: "HR",
  },
  {
    label: "کوبا",
    value: "Cuba",
    code: "CU",
  },
  {
    label: "قبرس",
    value: "Cyprus",
    code: "CY",
  },
  {
    label: "جمهوری چک",
    value: "Czech Republic",
    code: "CZ",
  },
  {
    label: "دانمارک",
    value: "Denmark",
    code: "DK",
  },
  {
    label: "جیبوتی",
    value: "Djibouti",
    code: "DJ",
  },
  {
    label: "دومینیکا",
    value: "Dominica",
    code: "DM",
  },
  {
    label: "جمهوری دومینیکن",
    value: "Dominican Republic",
    code: "DO",
  },
  {
    label: "اکوادور",
    value: "Ecuador",
    code: "EC",
  },
  {
    label: "مصر",
    value: "Egypt",
    code: "EG",
  },
  {
    label: "السالوادور",
    value: "El Salvador",
    code: "SV",
  },
  {
    label: "گیینه استوایی",
    value: "Equatorial Guinea",
    code: "GQ",
  },
  {
    label: "اریتره",
    value: "Eritrea",
    code: "ER",
  },
  {
    label: "استونی",
    value: "Estonia",
    code: "EE",
  },
  {
    label: "اتیوپی",
    value: "Ethiopia",
    code: "ET",
  },
  {
    label: "جزایر فالکلند",
    value: "Falkland Islands",
    code: "FK",
  },
  {
    label: "جزایر فارو",
    value: "Faroe Islands",
    code: "FO",
  },
  {
    label: "فیجی",
    value: "Fiji",
    code: "FJ",
  },
  {
    label: "فنلاند",
    value: "Finland",
    code: "FI",
  },
  {
    label: "فرانسه",
    value: "France",
    code: "FR",
  },
  {
    label: "پلینزی فرانسه",
    value: "French Polynesia",
    code: "PF",
  },
  {
    label: "سرزمین های جنوبی و قطب جنوب فرانسه",
    value: "French Southern and Antarctic Lands",
    code: "TF",
  },
  {
    label: "گابن",
    value: "Gabon",
    code: "GA",
  },
  {
    label: "گامبیا",
    value: "Gambia",
    code: "GM",
  },
  {
    label: "گرجستان",
    value: "Georgia",
    code: "GE",
  },
  {
    label: "آلمان",
    value: "Germany",
    code: "DE",
  },
  {
    label: "غنا",
    value: "Ghana",
    code: "GH",
  },
  {
    label: "جبل الطارق",
    value: "Gibraltar",
    code: "GI",
  },
  {
    label: "یونان",
    value: "Greece",
    code: "EL",
  },
  {
    label: "گرینلند",
    value: "Greenland",
    code: "GL",
  },
  {
    label: "گرنادا",
    value: "Grenada",
    code: "GD",
  },
  {
    label: "گوادلوپ",
    value: "Guadeloupe",
    code: "GP",
  },
  {
    label: "گوام",
    value: "Guam",
    code: "GU",
  },
  {
    label: "گواتمالا",
    value: "Guatemala",
    code: "GT",
  },
  {
    label: "گرنزی",
    value: "Guernsey",
    code: "GG",
  },
  {
    label: "گینه",
    value: "Guinea",
    code: "GN",
  },
  {
    label: "گینه بیسائو",
    value: "Guinea-Bissau",
    code: "GW",
  },
  {
    label: "گویان",
    value: "Guyana",
    code: "GY",
  },
  {
    label: "هائیتی",
    value: "Haiti",
    code: "HT",
  },
  {
    label: "جزیره هرد و جزایر مک دونالد",
    value: "Heard Island and McDonald Islands",
    code: "HM",
  },
  {
    label: "ایالت شهر واتیکان (سریر مقدس)",
    value: "Vatican City State (Holy See)",
    code: "VA",
  },
  {
    label: "هندوراس",
    value: "Honduras",
    code: "HN",
  },
  {
    label: "هنگ کنگ",
    value: "Hong Kong",
    code: "HK",
  },
  {
    label: "مجارستان",
    value: "Hungary",
    code: "HU",
  },
  {
    label: "ایسلند",
    value: "Iceland",
    code: "IS",
  },
  {
    label: "هند",
    value: "India",
    code: "IN",
  },
  {
    label: "اندونزی",
    value: "Indonesia",
    code: "ID",
  },
  {
    label: "ایران",
    value: "Iran, Islamic Republic of",
    code: "IR",
  },
  {
    label: "عراق",
    value: "Iraq",
    code: "IZ",
  },
  {
    label: "ایرلند",
    value: "Ireland",
    code: "IE",
  },
  {
    label: "جزیره من",
    value: "Isle of Man",
    code: "IM",
  },
  {
    label: "اسرائیل",
    value: "Israel",
    code: "IL",
  },
  {
    label: "ایتالیا",
    value: "Italy",
    code: "IT",
  },
  {
    label: "جامائیکا",
    value: "Jamaica",
    code: "JM",
  },
  {
    label: "ژاپن",
    value: "Japan",
    code: "JP",
  },
  {
    label: "جرسی",
    value: "Jersey",
    code: "JE",
  },
  {
    label: "اردن",
    value: "Jordan",
    code: "JO",
  },
  {
    label: "قزاقستان",
    value: "Kazakhstan",
    code: "KZ",
  },
  {
    label: "کنیا",
    value: "Kenya",
    code: "KE",
  },
  {
    label: "کیریباتی",
    value: "Kiribati",
    code: "KI",
  },
  {
    label: "کره شمالی",
    value: "North Korea",
    code: "KP",
  },
  {
    label: "کره جنوبی",
    value: "South Korea",
    code: "KR",
  },
  {
    label: "کویت",
    value: "Kuwait",
    code: "KW",
  },
  {
    label: "قرقیزستان",
    value: "Kyrgyzstan",
    code: "KG",
  },
  {
    label: "لائوس",
    value: "Laos",
    code: "LA",
  },
  {
    label: "لتونی",
    value: "Latvia",
    code: "LV",
  },
  {
    label: "لبنان",
    value: "Lebanon",
    code: "LB",
  },
  {
    label: "لسوتو",
    value: "Lesotho",
    code: "LS",
  },
  {
    label: "لیبریا",
    value: "Liberia",
    code: "LR",
  },
  {
    label: "جمهریای عربی لیبی",
    value: "Libyan Arab Jamahiriya",
    code: "LY",
  },
  {
    label: "لیختن اشتاین",
    value: "Liechtenstein",
    code: "LI",
  },
  {
    label: "لیتوانی",
    value: "Lithuania",
    code: "LT",
  },
  {
    label: "لوکزامبورگ",
    value: "Luxembourg",
    code: "LU",
  },
  {
    label: "ماکائو",
    value: "Macau",
    code: "MO",
  },
  {
    label: "مقدونیه جمهوری یوگسلاوی سابق",
    value: "Macedonia, The Former Yugoslav Republic of",
    code: "MK",
  },
  {
    label: "ماداگاسکار",
    value: "Madagascar",
    code: "MG",
  },
  {
    label: "مالاوی",
    value: "Malawi",
    code: "MW",
  },
  {
    label: "مالزی",
    value: "Malaysia",
    code: "MY",
  },
  {
    label: "مالدیو",
    value: "Maldives",
    code: "MV",
  },
  {
    label: "مالی",
    value: "Mali",
    code: "ML",
  },
  {
    label: "مالتا",
    value: "Malta",
    code: "MT",
  },
  {
    label: "جزایر مارشال",
    value: "Marshall Islands",
    code: "MH",
  },
  {
    label: "مارتینیک",
    value: "Martinique",
    code: "MQ",
  },
  {
    label: "موریتانیا",
    value: "Mauritania",
    code: "MR",
  },
  {
    label: "موریس",
    value: "Mauritius",
    code: "MU",
  },
  {
    label: "مایوته",
    value: "Mayotte",
    code: "YT",
  },
  {
    label: "مکزیک",
    value: "Mexico",
    code: "MX",
  },
  {
    label: "میکرونزی ایالات فدرال",
    value: "Micronesia, Federated States of",
    code: "FM",
  },
  {
    label: "مولداوی جمهوری",
    value: "Moldova, Republic of",
    code: "MD",
  },
  {
    label: "موناکو",
    value: "Monaco",
    code: "MC",
  },
  {
    label: "مغولستان",
    value: "Mongolia",
    code: "MN",
  },
  {
    label: "مونته نگرو",
    value: "Montenegro",
    code: "ME",
  },
  {
    label: "مونتسرات",
    value: "Montserrat",
    code: "MS",
  },
  {
    label: "مراکش",
    value: "Morocco",
    code: "MA",
  },
  {
    label: "موزامبیک",
    value: "Mozambique",
    code: "MZ",
  },
  {
    label: "میانمار",
    value: "Myanmar",
    code: "MM",
  },
  {
    label: "نامیبیا",
    value: "Namibia",
    code: "NA",
  },
  {
    label: "نائورو",
    value: "Nauru",
    code: "NR",
  },
  {
    label: "نپال",
    value: "Nepal",
    code: "NP",
  },
  {
    label: "هلند",
    value: "Netherlands",
    code: "NL",
  },
  {
    label: "آنتیل هلند",
    value: "Netherlands Antilles",
    code: "AN",
  },
  {
    label: "کالدونیای جدید",
    value: "New Caledonia",
    code: "NC",
  },
  {
    label: "نیوزیلند",
    value: "New Zealand",
    code: "NZ",
  },
  {
    label: "نیکاراگوئه",
    value: "Nicaragua",
    code: "NI",
  },
  {
    label: "نیجر",
    value: "Niger",
    code: "NE",
  },
  {
    label: "نیجریه",
    value: "Nigeria",
    code: "NG",
  },
  {
    label: "Niue",
    value: "Niue",
    code: "NU",
  },
  {
    label: "جزیره نورفولک",
    value: "Norfolk Island",
    code: "NF",
  },
  {
    label: "جزایر ماریانای شمالی",
    value: "Northern Mariana Islands",
    code: "MP",
  },
  {
    label: "نروژ",
    value: "Norway",
    code: "NO",
  },
  {
    label: "عمان",
    value: "Oman",
    code: "OM",
  },
  {
    label: "پاکستان",
    value: "Pakistan",
    code: "PK",
  },
  {
    label: "پالائو",
    value: "Palau",
    code: "PW",
  },
  {
    label: "سرزمین فلسطین اشغالی",
    value: "Palestinian Territory, Occupied",
    code: "PalestinE",
  },
  {
    label: "پاناما",
    value: "Panama",
    code: "PA",
  },
  {
    label: "پاپوآ گینه نو",
    value: "Papua New Guinea",
    code: "PG",
  },
  {
    label: "پاراگوئه",
    value: "Paraguay",
    code: "PY",
  },
  {
    label: "پرو",
    value: "Peru",
    code: "PE",
  },
  {
    label: "فیلیپین",
    value: "Philippines",
    code: "PH",
  },
  {
    label: "Pitcairn",
    value: "Pitcairn",
    code: "PN",
  },
  {
    label: "لهستان",
    value: "Poland",
    code: "PL",
  },
  {
    label: "پرتغال",
    value: "Portugal",
    code: "PT",
  },
  {
    label: "پورتوریکو",
    value: "Puerto Rico",
    code: "PR",
  },
  {
    label: "قطر",
    value: "Qatar",
    code: "QA",
  },
  {
    label: "رئونیون",
    value: "Réunion",
    code: "RE",
  },
  {
    label: "رومانی",
    value: "Romania",
    code: "RO",
  },
  {
    label: "روسیه",
    value: "Russia",
    code: "RU",
  },
  {
    label: "روآندا",
    value: "Rwanda",
    code: "RW",
  },
  {
    label: "سنت هلنا عروج و تریستان دا کونا",
    value: "Saint Helena, Ascension and Tristan Da Cunha",
    code: "SH",
  },
  {
    label: "سنت کیتس و نویس",
    value: "Saint Kitts and Nevis",
    code: "KN",
  },
  {
    label: "سنت لوسیا",
    value: "Saint Lucia",
    code: "LC",
  },
  {
    label: "سنت پیر و میکلون",
    value: "Saint Pierre and Miquelon",
    code: "PM",
  },
  {
    label: "سنت وینسنت و گرنادین ها",
    value: "Saint Vincent and the Grenadines",
    code: "VC",
  },
  {
    label: "ساموآ",
    value: "Samoa",
    code: "WS",
  },
  {
    label: "سان مارینو",
    value: "San Marino",
    code: "SM",
  },
  {
    label: "سائو تومه و پرینسیپ",
    value: "Sao Tome and Principe",
    code: "ST",
  },
  {
    label: "عربستان سعودی",
    value: "Saudi Arabia",
    code: "SA",
  },
  {
    label: "سنگال",
    value: "Senegal",
    code: "SN",
  },
  {
    label: "صربستان",
    value: "Serbia",
    code: "RS",
  },
  {
    label: "سیشل",
    value: "Seychelles",
    code: "SC",
  },
  {
    label: "سیرالئون",
    value: "Sierra Leone",
    code: "SL",
  },
  {
    label: "سنگاپور",
    value: "Singapore",
    code: "SG",
  },
  {
    label: "اسلواکی",
    value: "Slovakia",
    code: "SK",
  },
  {
    label: "اسلوونی",
    value: "Slovenia",
    code: "SI",
  },
  {
    label: "جزایر سلیمان",
    value: "Solomon Islands",
    code: "SB",
  },
  {
    label: "سومالی",
    value: "Somalia",
    code: "SO",
  },
  {
    label: "آفریقای جنوبی",
    value: "South Africa",
    code: "ZA",
  },
  {
    label: "گرجستان جنوبی و جزایر ساندویچ جنوبی",
    value: "South Georgia and the South Sandwich Islands",
    code: "GS",
  },
  {
    label: "اسپانیا",
    value: "Spain",
    code: "ES",
  },
  {
    label: "سری لانکا",
    value: "Sri Lanka",
    code: "LK",
  },
  {
    label: "سودان",
    value: "Sudan",
    code: "SU",
  },
  {
    label: "سورینام",
    value: "Suriname",
    code: "NS",
  },
  {
    label: "سوالبارد و یان ماین",
    value: "Svalbard and Jan Mayen",
    code: "SJ",
  },
  {
    label: "سوازیلند",
    value: "Swaziland",
    code: "SZ",
  },
  {
    label: "سوئد",
    value: "Sweden",
    code: "SW",
  },
  {
    label: "سوئیس",
    value: "Switzerland",
    code: "SZ",
  },
  {
    label: "سوریه",
    value: "Syria",
    code: "SY",
  },
  {
    label: "تایوان",
    value: "Taiwan",
    code: "TW",
  },
  {
    label: "تاجیکستان",
    value: "Tajikistan",
    code: "TI",
  },
  {
    label: "تانزانیا جمهوری متحد",
    value: "Tanzania, United Republic of",
    code: "TZ",
  },
  {
    label: "تایلند",
    value: "Thailand",
    code: "TH",
  },
  {
    label: "تیمور شرقی",
    value: "Timor-Leste",
    code: "TT",
  },
  {
    label: "توگو",
    value: "Togo",
    code: "TO",
  },
  {
    label: "توکلائو",
    value: "Tokelau",
    code: "TK",
  },
  {
    label: "تونگا",
    value: "Tonga",
    code: "TN",
  },
  {
    label: "ترینیداد و توباگو",
    value: "Trinidad and Tobago",
    code: "TD",
  },
  {
    label: "تونس",
    value: "Tunisia",
    code: "TS",
  },
  {
    label: "ترکیه",
    value: "Turkey",
    code: "TU",
  },
  {
    label: "ترکمنستان",
    value: "Turkmenistan",
    code: "TX",
  },
  {
    label: "جزایر تورکس و کایکوس",
    value: "Turks and Caicos Islands",
    code: "TC",
  },
  {
    label: "تووالو",
    value: "Tuvalu",
    code: "TV",
  },
  {
    label: "اوگاندا",
    value: "Uganda",
    code: "UG",
  },
  {
    label: "اوکراین",
    value: "Ukraine",
    code: "UP",
  },
  {
    label: "امارات متحده عربی",
    value: "United Arab Emirates",
    code: "AE",
  },
  {
    label: "بریتانیا",
    value: "United Kingdom",
    code: "UK",
  },
  {
    label: "ایالات متحده",
    value: "United States",
    code: "US",
  },
  {
    label: "جزایر کوچک دورافتاده ایالات متحده",
    value: "United States Minor Outlying Islands",
    code: "UM",
  },
  {
    label: "اروگوئه",
    value: "Uruguay",
    code: "UY",
  },
  {
    label: "ازبکستان",
    value: "Uzbekistan",
    code: "UZ",
  },
  {
    label: "وانواتو",
    value: "Vanuatu",
    code: "NH",
  },
  {
    label: "ونزوئلا جمهوری بولیواری",
    value: "Venezuela, Bolivarian Republic of",
    code: "VE",
  },
  {
    label: "ویتنام",
    value: "Vietnam",
    code: "VN",
  },
  {
    label: "جزایر ویرجین بریتانیا",
    value: "Virgin Islands, British",
    code: "VG",
  },
  {
    label: "جزایر ویرجین ایالات متحده",
    value: "Virgin Islands, U.S.",
    code: "VI",
  },
  {
    label: "والیس و فوتونا",
    value: "Wallis and Futuna",
    code: "WF",
  },
  {
    label: "صحرای غربی",
    value: "Western Sahara",
    code: "EH",
  },
  {
    label: "یمن",
    value: "Yemen",
    code: "YM",
  },
  {
    label: "زامبیا",
    value: "Zambia",
    code: "ZA",
  },
  {
    label: "زیمباوه",
    value: "Zimbabwe",
    code: "ZI",
  },
];
